import axios from '@providers/axiosProvider';
import * as actions from './actions';
import { APIGetDailyPlansRequestParams, APIGetDailyPlansResponse, SearchParameter } from './types';
import { formatDateString } from '@utils/dateUtils';

/**
 * @summary 検索パラメータを元に日時計画のリストを取得
 * @param {number | null} propertyId 建物ID
 * @param {number} year 年
 * @param {number} month 月
 * @param {number} day 日
 * @param {number} sort ソート番号
 * @param {string} keyword 検索キーワード
 * @param {SearchParameter} params 詳細検索条件
 * @param {number[]} tagIds 選択タグIDリスト
 * @returns {void}
 */
export const getPlansDailyAsync =
  (
    propertyId: number | null,
    year: number,
    month: number,
    day: number,
    sort: number,
    keyword: string,
    params: SearchParameter,
    tagIds: number[],
  ) =>
  async (dispatch: any) => {
    dispatch(actions.setIsLoading(true));
    const reqParams: APIGetDailyPlansRequestParams = {
      ...params,
      date: formatDateString(`${year}/${month}/${day}`, 'ui'),
      sort: sort,
    };

    if (propertyId != null) reqParams.property_id = propertyId;
    if (keyword) reqParams.keyword = keyword;
    if (tagIds.length) reqParams.tag = tagIds.join(',');

    await axios
      .get<APIGetDailyPlansResponse>('/plans/daily', {
        params: reqParams,
      })
      .then((response) => {
        const { items, summary } = response.data.result;
        dispatch(actions.setPlans(items));
        dispatch(actions.setSummary(summary));
      })
      .catch(() => {
        dispatch(actions.setPlans([]));
        dispatch(actions.setSummary(null));
      });

    dispatch(actions.setIsLoading(false));
  };
